import { getEnvironment } from './environment';

export const initEnvironmentRibbon = () => {
    const env = getEnvironment();
    if (env === 'production') return;

    const ribbon = document.createElement('div');
    
    // Configurações de cores e textos com base no ambiente
    const settings = { label: 'DESENVOLVIMENTO', bg: 'bg-red-600', text: 'text-white' };

    // Container fixo para servir de âncora, sem overflow hidden para não cortar a sombra
    ribbon.className = `env-ribbon fixed top-0 right-0 z-[9999] pointer-events-none`;
    
    // O Ribbon propriamente dito, inclinado em 45 graus
    ribbon.innerHTML = `
        <div class="env-ribbon-band absolute top-[38px] -right-[68px] w-[300px] transform rotate-45 ${settings.bg} shadow-xl py-1" style="background-color: ${env === 'development' ? '#dc2626' : '#ff9900'};">
            <div class="border border-white/20 py-0.5 text-center pointer-events-auto cursor-help pl-6" title="Ambiente: ${env.toUpperCase()}. Use localStorage.setItem('GM_ENV_OVERRIDE', 'production') para simular produção.">
                <span class="font-black ${settings.text} text-[11px] tracking-[0.2em] uppercase">${settings.label}</span>
            </div>
        </div>
    `;

    document.body.appendChild(ribbon);
};
